import { createSlice } from '@reduxjs/toolkit'
import type { RootState } from '../../app/store'

const authSlice = createSlice({
    name: 'auth',
    initialState: { token: null, loginStatus: false, userId: "", authChecked: false, },
    reducers: {
        setCredentials: (state, action) => {
            const { jwt, userId, loginStatus } = action.payload
            state.token = jwt
            state.userId = userId
            state.loginStatus = loginStatus
            state.authChecked = true
        },
        logOut: (state, action) => {
            state.token = null
        },
        setLogin: (state, action) => {
            const { loginStatus } = action.payload;
            state.loginStatus = loginStatus;
        },
        // Marks that the initial checkLogin round-trip has completed (whether the
        // visitor turned out to be logged in or not), so UI can distinguish
        // "logged out" from "not yet known".
        setAuthChecked: (state) => {
            state.authChecked = true;
        }
    }
})

export const { setCredentials, logOut, setLogin, setAuthChecked } = authSlice.actions

export default authSlice.reducer

export const selectCurrentToken = (state: RootState) => state.auth.token
export const selectCurrentUserId = (state: RootState) => state.auth.userId
export const selectLoginStatus = (state: RootState) => state.auth.loginStatus
export const selectAuthChecked = (state: RootState) => state.auth.authChecked